import 'twin.macro';

import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useSearchParams } from 'react-router-dom';

import { Step } from '../../App';
import { StyledCard } from '../../App.styles';
import { AuthFlowHeader } from '../AuthFlowHeader';
import { useLoginWithOAuthCode } from './api.hooks';

export const SsoRedirectStep: FC = () => {
	const [params] = useSearchParams();
	const { t } = useTranslation();

	useLoginWithOAuthCode();

	// Get the params from the url and use them to identify with the python API
	const code = params.get('code');
	const state = params.get('state');
	const errorDescription = params.get('error_description');

	if (errorDescription) {
		return (
			<Navigate
				to={Step.SELECT_WORKSPACE}
				state={{
					error: params.get('error_description'),
				}}
			/>
		);
	} else if (!code || !state) {
		return <Navigate to={Step.ENTER_EMAIL} />;
	}

	return (
		<StyledCard sectioned spacing="large">
			<AuthFlowHeader
				spacing="loose"
				heading={t('sso_redirect_step.header')}
				subheading={t('sso_redirect_step.redirect_message')}
				headingAlign="center"
			/>
		</StyledCard>
	);
};
